import { JobFunction, JobFunctionLabels } from '@/bundles/Members/enums';

export const memberJobFunctions = [
  { text: JobFunctionLabels[JobFunction.salesperson], value: JobFunction.salesperson },
  { text: JobFunctionLabels[JobFunction.coordinator], value: JobFunction.coordinator },
  { text: JobFunctionLabels[JobFunction.research], value: JobFunction.research },
  { text: JobFunctionLabels[JobFunction.manager], value: JobFunction.manager },
  { text: JobFunctionLabels[JobFunction.marketing], value: JobFunction.marketing },
  { text: JobFunctionLabels[JobFunction.it], value: JobFunction.it },
  { text: JobFunctionLabels[JobFunction.intern], value: JobFunction.intern },
  { text: JobFunctionLabels[JobFunction.finance], value: JobFunction.finance },
  { text: JobFunctionLabels[JobFunction.data_entry], value: JobFunction.data_entry },
  { text: JobFunctionLabels[JobFunction.data_analyst], value: JobFunction.data_analyst },
  { text: JobFunctionLabels[JobFunction.executive], value: JobFunction.executive },
  { text: JobFunctionLabels[JobFunction.admin], value: JobFunction.admin }
];
